  // create a container and set the full-size image as its background
function createOverlay(image) {
  const overlay = document.createElement('div'); // <-- no global
  const overlayImage = new Image();
  overlayImage.src = image.currentSrc || image.src;

  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
  container.style.backgroundRepeat = 'no-repeat';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement?.parentElement?.querySelector('.loading__spinner');
  if (loadingSpinner) loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, overlay, event, zoomRatio) {
  if (!overlay) return;
  const rect = image.getBoundingClientRect();
  const x = event.clientX - rect.left;
  const y = event.clientY - rect.top;
  const xPercent = `${(x / rect.width) * 100}%`;
  const yPercent = `${(y / rect.height) * 100}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${rect.width * zoomRatio}px ${rect.height * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  const cleanup = () => overlay?.remove();

  overlay.addEventListener('mousemove', (e) => moveWithHover(image, overlay, e, zoomRatio));
  overlay.addEventListener('mouseleave', cleanup);
  overlay.addEventListener('click', cleanup);
}

function enableZoomOnHover(zoomRatio) {
  document.querySelectorAll('.product__media').forEach((container) => {
    const img = container.querySelector('img');
    if (!img) return;

    // guard so we don’t double-bind if called again
    if (container.dataset.zoomBound === '1') return;
    container.dataset.zoomBound = '1';

    let overlayEl = null;

    container.addEventListener('mouseenter', (e) => {
      // clean any leftover overlays in this container
      container.querySelectorAll('.image-magnify-full-size').forEach(n => n.remove());
      overlayEl = createOverlay(img);
      moveWithHover(img, overlayEl, e, zoomRatio);
    });

    container.addEventListener('mousemove', (e) => {
      if (overlayEl) moveWithHover(img, overlayEl, e, zoomRatio);
    });

    container.addEventListener('mouseleave', () => {
      overlayEl?.remove();
      overlayEl = null;
    });
  });
}

enableZoomOnHover(2);
